//
// Global Nav (JS)
// 2019-04-25
// Space-Time Inc.
//

// Definition of Constant and Variable Values
const timeOut = 200;
var leaveEvent = null;
var enterEvent = null;

var globalnav = document.querySelector('.site-global-nav');
var mis = document.querySelectorAll('.site-global-nav > .menu > li');
var mis_sub = document.querySelectorAll('.site-global-nav-sub > .menu');

// Definition of Events

document.addEventListener('DOMContentLoaded', function () {

	if (globalnav !== null) {
		setEventListenerforGlobalNav(globalnav);

		for (var i = 0; i < mis.length; i += 1) {
			setEventListenerforMenuItems(mis[i]);
		}
	}

});

// Definition of Functions
function setEventListenerforGlobalNav(item) {

	item.addEventListener('mouseleave', function (e) {
		leaveEvent = setTimeout(function () {
			clearOpendState(mis);
			clearVisibleState(mis_sub);
		}, timeOut);
	});

	item.addEventListener('mouseenter', function (e) {
		clearTimeout(leaveEvent);
	});
}

function setEventListenerforMenuItems(item) {
	var labs = item.getElementsByTagName('LABEL');
	if (labs.length === 0) return;


	labs[0].addEventListener('mouseenter', function (e) {
		enterEvent = setTimeout(controlVisibleAndOpenedByID(item, mis, mis_sub), timeOut);
	});

	labs[0].addEventListener('mouseleave', function (e) {
		clearTimeout(enterEvent);
	});

	labs[0].addEventListener('touchstart', function (e) {
		e.preventDefault();
		controlVisibleAndOpenedByID(item, mis, mis_sub);
	});
}

function clearVisibleState(objs) {
	for (var i = 0; i < objs.length; i += 1) {
		objs[i].classList.remove('visible');
	}
}

function clearOpendState(objs) {
	for (var i = 0; i < objs.length; i += 1) {
		objs[i].classList.remove('opened');
	}
}

function controlVisibleAndOpenedByID(item, parents, children) {
	var num = String(item['id']).match(/[0-9]+\.?[0-9]*/g);
	var c_class = ".site-global-nav-sub .pid-" + num;
	var obj = document.querySelectorAll(c_class);
	if (obj.length > 0) {
		var visible = obj[0].classList.contains('visible');
		clearVisibleState(children);
		if (!visible) {
			obj[0].classList.add('visible');
		};
	};
	var opened = item.classList.contains('opened');
	clearOpendState(parents);
	if (!opened) {
		item.classList.add('opened');
	}
}
